import { AccountsAPI } from "./axios.config";

export const getBankRecNominals = () =>
  AccountsAPI.get(`/nominals?banks=true&Orderby=subType,nominalRef`);

export const addNominal = (data) =>
  AccountsAPI.post(`/nominals`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getOfficeBankNominals = () =>
  AccountsAPI.get(`/nominals?subtype=BalanceSheet_OfficeBank&archived=false`);

export const getclientList = () =>
  AccountsAPI.get(`/nominals?subtype=BalanceSheet_ClientBank&archived=false`);

export const getddaList = () =>
  AccountsAPI.get(`/nominals?subtype=BalanceSheet_DDABank&archived=false`);

export const getViewNominals = (id) => AccountsAPI.get(`/nominals/${id}`);

export const updateNominal = (id, data) =>
  AccountsAPI.patch(`/nominals/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const searchNominal = (page, limit, search) =>
  AccountsAPI.get(`/nominals?search=${search}&page=${page}&limit=${limit}`);

export const getNominalBalances = (nominalRef, FromDate, ToDate) =>
  AccountsAPI.get(
    `/nominals/Ref/${nominalRef}/Balances?FromDate=${FromDate}&ToDate=${ToDate}`
  );

export const getNominalsByRef = (nominalRef) =>
  AccountsAPI.get(`/nominals/Ref/${nominalRef}`);

export const getactivenominals = () =>
  AccountsAPI.get(`/nominals?archived=false&active=true`);

export const getActiveIncomeNominals = () =>
  AccountsAPI.get(`/nominals?banks=false&Orderby=subType,nominalRef`);

export const getBankTransferNominals = () =>
  AccountsAPI.get(
    `/nominals?subType=BalanceSheet_OfficeBank&active=true&Orderby=subType,nominalRef`
  );

export const getIncomeNominals = () =>
  AccountsAPI.get(
    "/nominals?archived=false&active=true&subtype=ProfitAndLoss_Income"
  );

export const getDDABankNominals = () =>
  AccountsAPI.get(
    "/nominals?archived=false&active=true&subtype=BalanceSheet_DDABank"
  );

export const getBillRequestsList = (page, limit, parameter) =>
  AccountsAPI.get(`/BillRequest?${parameter}&page=${page}&limit=${limit}`);

export const getNominalsByType = (type) =>
  AccountsAPI.get(`/nominals?type=${type}&active=true`);

export const getNominalsList = (parameter) => {
  let url = `/nominals?`;
  if (parameter !== "") {
    url += `${parameter}`;
  }
  return AccountsAPI.get(url);
};

export const getNominalJournalPosting = () =>
  AccountsAPI.get(`/nominals?archived=false&controlNominal=false`);

export const getNominalsBySubtype = (
  subtype,
  active = true,
  archived = false
) => {
  return AccountsAPI.get(
    `/nominals?subtype=${subtype}&active=${active}&archived=${archived}`
  );
};

export const editPosting = (transactionNo, data) =>
  AccountsAPI.patch(`/postings/${transactionNo}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const reversePosting = (transactionNo, data) =>
  AccountsAPI.request({
    url: `/postings/${transactionNo}`,
    method: "DELETE",
    data: JSON.stringify({ data }),
    headers: { "Content-Type": "application/json" },
  });

export const getTransactionPeriod = (page, limit) =>
  AccountsAPI.get(`/TransactionPeriods`);

export const getCurrentSessionTransactionPeriod = (sessionPeriod) =>
  AccountsAPI.get(`/TransactionPeriods/Current?sessionPeriod=${sessionPeriod}`);

export const getCurrentTransactionPeriod = () =>
  AccountsAPI.get(`/TransactionPeriods/Current`);

export const updateTransactionPeriod = (data) =>
  AccountsAPI.post(`/TransactionPeriods`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getDefaultNominals = (branchId) =>
  AccountsAPI.get(`/DefaultNominal/${branchId}`);

export const getNewDefaultNominals = (branchId) =>
  AccountsAPI.get(`/DefaultNominal/${branchId}/New`);

export const getAuthorizations = () => AccountsAPI.get(`/Authorisations`);

export const updateAuthoriations = (data) =>
  AccountsAPI.patch(`/Authorisations`, JSON.stringify({ data: data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateDefaultNominals = (branchId, data) =>
  AccountsAPI.post(`/DefaultNominal/${branchId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getReportTemplates = (type) =>
  AccountsAPI.get(`/ReportTemplates?reportType=${type}`);

export const addReportTemplate = (data, type) =>
  AccountsAPI.post(
    `/ReportTemplates?reportType=${type}`,
    JSON.stringify({ data }),
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const editReportTemplate = (data, type, id) =>
  AccountsAPI.patch(
    `/ReportTemplates/${id}?reportType=${type}`,
    JSON.stringify({ data }),
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const getPreviousTransactions = (
  matterId,
  nominalRef,
  supplierRef,
  page = 1,
  limit = 200
) => {
  let url = `/PreviousTransactions?`;

  url += `page=${page}&limit=${limit}`;

  if (matterId) {
    url += `&MatterID=${matterId}`;
  }
  if (nominalRef) {
    url += `&nominalRef=${nominalRef}`;
  }
  if (supplierRef) {
    url += `&supplierRef=${supplierRef}`;
  }

  return AccountsAPI.get(url);
};

export const getChartOfAccounts = () => AccountsAPI.get(`/ChartOfAccounts`);

export const createChartOfAccounts = (data) =>
  AccountsAPI.post(`/ChartOfAccounts`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateChartOfAccounts = (id, data) =>
  AccountsAPI.patch(`/ChartOfAccounts/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getChartOfAccountBalance = (type) =>
  AccountsAPI.get(
    `/ChartOfAccounts?type=${type}&active=true&fields=chartOfAccountId,name,type&orderby=name`
  );

export const getBankRecData = (nominlaId, reconcile) =>
  AccountsAPI.get(`/bankrec/${nominlaId}?todate=${reconcile}`);

export const addBankRecs = (nominalRef, data) =>
  AccountsAPI.post(`/bankrec/${nominalRef}/save`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const postBankRecs = (nominalRef, data) =>
  AccountsAPI.post(`/bankrec/${nominalRef}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const editFeeHeader = (id, data) =>
  AccountsAPI.patch(`/Bill/FixedFeeHeaders/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const createFixedFeeHeaderItems = (id, data) =>
  AccountsAPI.post(`/Bill/FixedFeeItems/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getFeeHeaderItems = (id) =>
  AccountsAPI.get(`/Bill/FixedFeeItems/${id}`);

export const getActiveFeeItems = (id) =>
  AccountsAPI.get(`/Bill/FixedFeeItems/${id}?active=true`);

export const editFeeHeaderItems = (id, data) =>
  AccountsAPI.put(`/Bill/FixedFeeItems/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getProfitCostDetails = () =>
  AccountsAPI.get(`/Bill/FixedFeeHeaders`);

export const getActiveFeeHeaders = () =>
  AccountsAPI.get(
    `/Bill/FixedFeeHeaders?active=true&type=Profitcost&Fields=fixedFeeHeaderID,name`
  );

export const addProfitCostTemplate = (data) =>
  AccountsAPI.post(`/Bill/FixedFeeHeaders`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getBillingRequestDetails = (id) =>
  AccountsAPI.get(`/BillRequest/${id}`);

export const AuthorizeChits = (data) =>
  AccountsAPI.post(`/Chits/Authorise`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getBankRec = (subtype) => {
  const url = subtype
    ? `/BankRec?active=true&subtype=${subtype}`
    : `/BankRec?active=true`;
  return AccountsAPI.get(url);
};

export const getSuppliersList = (parameters) => {
  let url = `/Suppliers?`;
  if (parameters !== "") {
    url += parameters;
  }
  return AccountsAPI.get(url);
};

export const addSupplier = (data) =>
  AccountsAPI.post(`/Suppliers`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getViewSupplier = (id) => AccountsAPI.get(`/Suppliers/${id}`);

export const updateSupplier = (id, data) =>
  AccountsAPI.patch(`/Suppliers/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
export const searchSupplier = (page, limit, search) =>
  AccountsAPI.get(`/Suppliers?search=${search}&page=${page}&limit=${limit}`);

export const getactiveVats = () => AccountsAPI.get(`/VatCodes?active=true`);

export const getVatcodes = (page, limit) =>
  AccountsAPI.get(`/VatCodes?page=${page}&limit=${limit}`);

export const addnewVat = (data) =>
  AccountsAPI.post(`/VatCodes`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editVatinfo = (id, data) =>
  AccountsAPI.patch(`/VatCodes/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getCurrency = () => AccountsAPI.get(`/Currencies`);

export const editCurrencyinfo = (id, data) =>
  AccountsAPI.patch(`/Currencies/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const addnewCurrency = (data) =>
  AccountsAPI.post(`/Currencies`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getActiveCurrency = () =>
  AccountsAPI.get(`/Currencies?active=true`);

export const createposting = (data, options = {}) => {
  const { allowOverdrawn = false, authcode } = options;
  let url = `/Postings`;
  const qp = [];
  if (allowOverdrawn) qp.push(`allowOverdrawn=true`);
  if (authcode) qp.push(`authcode=${encodeURIComponent(authcode)}`);
  if (qp.length) url += `?${qp.join("&")}`;
  return AccountsAPI.post(url, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
};

export const createBillingRequest = (data) =>
  AccountsAPI.post(`/BillRequest`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const rejectBillingReqeust = (id) =>
  AccountsAPI.post(`/BillRequest/${id}/Reject`, {
    headers: { "Content-Type": "application/json" },
  });

export const createChitRequest = (data) =>
  AccountsAPI.post(`/Chits`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getChitRequest = (id) =>
  AccountsAPI.get(`/Chits/${id}`);

export const updateChitRequest = (id, data) =>
  AccountsAPI.patch(`/Chits/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json-patch+json" },
  });

export const getChitDocuments = (chitId) =>
    AccountsAPI.get(`/Chits/${chitId}/Documents`);

export const createpostingJournal = (data) =>
  AccountsAPI.post(`/Postings`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getSuppliersByRef = (supplierRef) =>
  AccountsAPI.get(`/Suppliers/Ref/${supplierRef}`);

export const getSupplierBalances = (supplierRef, FromDate, ToDate, type) => {
  let url = `/Suppliers/Ref/${supplierRef}/Balances?FromDate=${FromDate}&ToDate=${ToDate}`;
  if (type) {
    url += `&type=${type}`;
  }
  return AccountsAPI.get(url);
};

export const getSupplierrefs = () => AccountsAPI.get(`/Suppliers?active=true`);

export const getConsultantRefs = () =>
  AccountsAPI.get(`/Suppliers?type=Consultant&active=true`);

export const getPostingdetails = (id) => AccountsAPI.get(`/Postings/${id}`);

export const getMattersBalances = (id) =>
  AccountsAPI.get(`/Postings/Matters/${id}/Balances`);

export const getMattersPostings = (id, type) =>
  AccountsAPI.get(`/Postings/Matters/${id}?LedgerPostingType=${type}`);

export const getChitPostingList = (page, limit, parameter, orderby) => {
  let url = `/Chits?page=${page}&limit=${limit}`;

  if (parameter) {
    url += `&${parameter}`;
  }

  if (orderby) {
    url += `&orderby=${orderby}`;
  }

  return AccountsAPI.get(url);
};

export const getDisbursementMatterList = (matterId) =>
  AccountsAPI.get(`/Postings/Matters/${matterId}/UnpaidDisb`);

export const getPaySupplierList = (supplierId, transactionType, type) => {
  let url = `/Postings/Supplier/${supplierId}/UnpaidDisb`;

  if (transactionType) {
    url += `?transactiontype=${transactionType}`;
  }
  if (type) {
    url += `?type=${type}`;
  }

  return AccountsAPI.get(url);
};

export const getUnpaidMatterList = (matterId) =>
  AccountsAPI.get(`/Postings/Matters/${matterId}/UnpaidSales`);

export const getMatterDisbRecords = (matterId) =>
  AccountsAPI.get(`/Postings/Matters/${matterId}/UnbilledDisb`);

export const getPostingDocuments = (transcNo) =>
  AccountsAPI.get(`/Postings/${transcNo}/Documents`);


export const getDashboardDebtorsData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate
) => {
  let url = `/Dashboard/Debtors?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return AccountsAPI.get(url);
};

export const getDashboardCreditorsData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate
) => {
  let url = `/Dashboard/Creditors?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return AccountsAPI.get(url);
};

export const getDashboardBillingTargetData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate
) => {
  let url = `/Dashboard/BillingTarget?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return AccountsAPI.get(url);
};

export const importSampleChit = () => AccountsAPI.get(`/Chits/Import`);

export function constructApiQuery(branch, team, feeEarner) {
  let query = {};
  if (feeEarner && feeEarner !== "ALL") {
    query.FeeEarnerRef = feeEarner;
  } else if (team && team !== -2) {
    query.TeamID = team;
  } else if (branch && branch > 0) {
    query.BranchId = branch;
  }

  return query;
}

export const getCTOSweep = (page, limit, parameter, orderby) => {
  let url = `/CTOSweep?Page=${page}&Limit=${limit}`;
  if (parameter.billsOnly) {
    url += `&BillsOnly=${parameter.billsOnly}`;
  }
  if (parameter.includeRingfenced) {
    url += `&IncludeRingFenced=${parameter.includeRingfenced}`;
  }
  if (orderby) {
    url += `&OrderBy=${orderby}`;
  }
  return AccountsAPI.get(url);
};

export const postCTOSweep = (data) =>
  AccountsAPI.post(`/CTOSweep`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
